export { default as EditProfileAvatar } from "./EditProfileAvatar";
